
import axios from 'axios'
import env from "./config/env"
//expose axios to global object
window.axios = axios;

window.axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token')

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

// Antes apontava para env.webserviceHost/env.webservicePort, que nunca
// existiram em config/env.js — o Echo nunca chegava a conectar em lugar
// nenhum. laravel-echo 1.16 (já instalado) suporta broadcaster: 'reverb'
// nativamente, usando o mesmo protocolo compatível com Pusher que o
// beyondcode/laravel-websockets usava, agora servido por `artisan reverb:start`.
window.Echo = new Echo({
    broadcaster: 'reverb',
    key: env.reverbKey,
    wsHost: env.reverbHost,
    wsPort: env.reverbPort,
    wssPort: env.reverbPort,
    forceTLS: env.reverbScheme === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: env.normalURL + 'broadcasting/auth',
    auth: {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    },
});

window.$ = window.jQuery = require('jquery');
require('bootstrap');
